import $ from 'jquery';

function FormRecherche(){
    $('.form-recherche').on('submit', function(e){
        e.preventDefault();
        var formData = {};
        $(this).find("input, select").each(function(){
            formData[this.name] = this.value;
        });
        window.location.href = formData.ville;
    })
}

export default FormRecherche;